import {RootState} from "../store.types"
import { SettingsState } from "./settings.types"

export const selectAppName: ((state: RootState) => SettingsState["appName"]) = ({settings}) => settings.appName

export const selectLogInRedirectUrl: ((state: RootState) => SettingsState["logInRedirectUrl"]) = ({settings}) => settings.logInRedirectUrl
